module.exports = __webpack_public_path__ + "static/media/S (28).e8b0430b.jpg";